import * as React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import { default as Old2005BlogPage, doNothingAnchor } from "../../components/Old2005BlogPage";

const OldBlogPage = () => (
  <Layout>
    <Seo title="Old 2005 Blog—June 2006" />
	<Old2005BlogPage>
		<h2>June 2006</h2>





		<h3 className="blogdate">
		Monday, June 26, 2006
		</h3>






		<h4 className="blogitemtitle">
		Fire twirling in Calgary?
		</h4>





			<div className="blogitembody">
			I was surprised to discover a fire twirling event tonight at <em>Oolong Tea House</em> in Kensington, Calgary, Alberta!  It was a backyard party to celebrate the establishment's second anniversary.<br /><br />Tonight was an interesting evening, really - one of those <em>it's funny how things work out</em> evenings.  I was feeling a little overwhelmed with some business so I stopped to make dinner.  As I was cleaning up I got a call from Tara's cousin, Amber.  We agreed to meet in <em>Riley Park</em> across the street.<br /><br />The days are long in the northern latitudes, shortly after summer solstice, so we had a good hour of sitting in the grass before we got up to explore the park.  I knew there was a drumming circle at the opposite end; as we approached we heard a large yet loose rhythm, and saw many people twirling practice (unlit) poi, staffs and hoolahoops.  We checked it out for a bit before deciding to go to Oolong for a tea.<br /><br />When we entered Oolong it was empty, and the tables and chairs were gone!  The lady behind the counter told us to go out back, and wow - that's where all the tables and chairs went.  There were musicians jamming and people scattered everywhere... it was a party!  We recognized people from the park as they appeared shortly after us.  Oolong was putting out varieties of free tea to drink, and there was a birthday cake!  As dusk became twilight, everyone formed a circle and the fire show began.<br /><br />Amber and I sat around the circle and watched several sets of twirling, from double poi, to snakes, to staffs, and... hoolahoops!  I've never seen flaming hoolahoops!  With drumming, cymbals and bells, Kensington neighbors were sure to hear the tribal energy, but they should have been there to see it!  As I watched, I very fondly reminisced of Aaron and Fi, Cormac and Kelly, Jess, and so many great twirlers that I met in Australia.  This twirling event wasn't quite as awesome as some I reminisced of, but it was so cool, nonetheless!<br /><br />I'm sorry I don't have pics... anyone agree that I need to get a digi cam?<br /><br />If Amber had not called me, I wouldn't have ventured to the drumming circle area of the park, nor gone to Oolong for a tea.  Amber and I agreed that both of our days were completely turned around (for the better) after we met up!  Yay :)  What a cool and unexpected evening!<br /><br />Related Links:<br /><br /><a href="http://oolonghouse.com/">Oolong Tea House</a>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 6:38 PM &nbsp;
			</div>











		<h4 className="blogitemtitle">
		Starving Muzo no longer
		</h4>





			<div className="blogitembody">
			This online journal is no longer titled <em>Starving Muzo</em>.  I'm not really starving, nor am I striving to starve.  Quite the opposite, I enjoy tasty meals, especially when they are home cooked using pure, natural ingredients!<br /><br />It is true that I live a simple, moderate lifestyle... but <em>starving</em> is a negative exaggeration.<br /><br />Today, I decided I like the ring of <em>Meandering Muso</em>... do you like it?
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 10:39 AM &nbsp;
			</div>






		<h3 className="blogdate">
		Monday, June 12, 2006
		</h3>






		<h4 className="blogitemtitle">
		Re: Generation
		</h4>





			<div className="blogitembody">
			Last night I went to a <em>THEATREboom</em> production called <em>Re: Generation</em>. It was wicked! It was tits! It's running until June 17th, at <em>Motel</em> in <em>Epcor Centre</em>, so there is still some time for you to get your bums into the theatre chairs, thus facilitating you to experience this production!<br /><br />I'm not going to say anything more about it; I think it's best to go in and be surprised (pleasantly, in my case).<br /><br />For tickets and info, go to the <a href="http://www.theatreboom.com/">THEATREboom website</a> (you'll see a Contact page, where you'll find a phone numbers and email addresses).
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 6:35 AM &nbsp;
			</div>











		<h4 className="blogitemtitle">
		Looking back:  Great Keppel Island
		</h4>





			<div className="blogitembody">
			I'd like to share a great, favorite photo with you! Last November I went to <em>Great Keppel Island</em>, with the beautiful and wonderful Jana, for a relaxing island weekend.<br /><br /><em>Great Keppel Island</em> is off of the east coast of Australia, near <em>Yeppoon</em> (which is near <em>Rockhampton</em>, where I lived). You can see in the picture that it is a short ferry ride away from the mainland.<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060611/islandsunset.jpg"
			alt="Great Keppel Island Australia"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={404}
			/>
			<br /><br />This photo is a favorite because it spawned from a vision and a realization. The realization was that I was sitting on an island at sunset, watching the sun descend over the ocean and beyond, over hills and mountains on the mainland. This was the first time I had seen such a sight! I've always been a west coast dude, and I'm accustomed to the sun setting <em>into</em> the ocean. So as Jana and I sat on the beach at <em>The Spit</em> (north point of <em>Fisherman's Beach</em>), and as I realized what I was seeing, I conjured this image in my mind. I even sketched it in my sketchbook before setting up my tripod and shooting the picture. The exposure and composition turned out super satisfactory!<br /><br />This photo takes me back, every time I see it. I reminisce about the refreshing island breeze that would saunter through our safari tent at night, and goofy rainbow lorikeets, stealthy sand goannas, and amusingly vicious possums that attacked my ankle. I remember drinking rain water and enjoying it, while showering in saline water and finding it pointless to shower. There wasn't much coral reef, yet I remember snorkelling with Jana and showing her how to find rays (and shocking us both after stirring up one particularly large dude). The water was crystal-clear green, and warm, and the sand was soft and white. It was a peaceful and refreshing break from our <em>Rockhampton</em> routine!<br /><br />I've been in Calgary now since January, and my body has forgotten the ocean. It has forgotten the relaxation, the inspiration, the charge and energy from swimming in, or standing next to, the ocean. My friend <em>Jess from Albany</em> told me that there are high levels of ozone and pure oxygen immediately above the surface of the water, which contributes to the addictiveness and rush of ocean swimming. When I read the words I wrote in my journal after any ocean memories, I am inspired to return to the ocean. A swim in the ocean is a great way to start your day, and is the first thing you should do when you knock off from work. It's great for midday excercise. It calms your body and mind, and destresses you. It strengthens you.<br /><br />Just watch out for stingers (box jelly fish, and a few other small jellies), salties (crocs), and white pointers (or any big sharks)... what am I saying? You're not going to see them coming. Have fun!<br /><br />Related Links:<br /><ul><li><a href="http://www.wilmap.com.au/qldmaps/great_keppel/default.htm">map</a></li><li><a href="http://www.gkiholidayvillage.com.au/">GKI Holiday Village</a></li><li><a href="http://www.teachers.ash.org.au/morrissey/gtkeppel/gtkeppel.htm">some students were studying human effect on GKI</a></li></ul>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 6:30 AM &nbsp;
			</div>











		<h4 className="blogitemtitle">
		Podcast: Little Ditty
		</h4>





			<div className="blogitembody">
			Here's a little ditty I wrote a long while ago... It's fun!  It was recorded using my unpatented <em>Stinksound</em> technology.<br /><ul><li><a href="/" onClick={doNothingAnchor}>(removed)</a></li></ul>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 4:52 AM &nbsp;
			</div>






		<h3 className="blogdate">
		Sunday, June 04, 2006
		</h3>






		<h4 className="blogitemtitle">
		Surprise blog from Daryl Hannah
		</h4>





			<div className="blogitembody">
			<em>Daryl Hannah</em> has a video blog, and it's pretty cool! I know little about Daryl except that she is an actress, yet I found myself surprised at the content of her blog. I stumbled upon it while following news and blogs regarding the <em>South Central Farmers</em> in L.A. I'm now subscribing to her blog through her site feed.<br /><br />It's called <a href="http://www.dhlovelife.com/"><strong>Daryl Hannah's Love Life</strong></a>, and I've watched her video posts on the <em>South Central Farmers</em>, as well as one on <em>hemp</em> and <em>bio diesel</em>. Check it out, it's great!<br /><br />Related Links:<br /><a href="http://news.google.ca/news?hl=en&tab=wn&amp;q=south+central+farmers&amp;ie=ISO-8859-1">Google News on South Central Farmers</a><br /><a href="http://savethegarden.blogspot.com/">South Central Farmers blog<br /></a>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 7:27 AM &nbsp;
			</div>






		<h3 className="blogdate">
		Friday, June 02, 2006
		</h3>






		<h4 className="blogitemtitle">
		House Concerts - be a music promoter
		</h4>





			<div className="blogitembody">
			You can be a <em>music promoter</em>! A music promoter is someone who organizes a performance of music - performance artists, venue, audience, etc.<br /><br />Promoting music, and <em>establishing</em> a cost and value for music, is very important. I've been dealing with some live music venues that won't charge entrance cover, and insist that the artists ask for money donations during a show. That is fear, that is not music promotion. Their fear is that there will be less patrons when an entrance cover is imposed. But if the music events are promoted, and if the promoter consistently promotes great shows, then value will be instilled and people will pay to see live music. I've seen it, it is true. Go to the <em>Espy</em> in <em>St. Kilda</em>. Go to <em>Karma</em> in <em>Calgary</em>. The <em>Hillhurst Sunnyside Community Association</em> has built itself a great reputation for music promotion and events, just this year!<br /><br />An easy way to get your start as a music promoter is to organize a house party with live music, also known as a <strong>House Concert</strong>. It doesn't have to be big! You can read a bit more about this concept through the following links.<br /><br />Related Links<br />- <a href="http://blog.myspace.com/index.cfm?fuseaction=blog.view&friendID=34180293&amp;blogID=84020161&amp;MyToken=d44cc26b-1b8d-4998-b3d6-5e685bc7d752">Joel Fafard on House Concerts</a><br />- <a href="http://www3.telus.net/oldfolk/housecon.htm">Bob Bossin on House Concerts</a>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 5:05 PM &nbsp;
			</div>











		<h4 className="blogitemtitle">
		I run a small business
		</h4>





			<div className="blogitembody">
			<p>Want to know what I do during my days? I have a day job, but outside of that, I do each of the jobs listed here - I run my own personal business! If I didn't have a day job, then I could focus more time on these jobs. However, I currently generate very little revenue in my personal business, and since I need food and shelter, I have a day job. And I am super grateful for it, too!</p><p>I aim to generate more revenue in my business, enough to live healthily and happily. But it's going to take time. Like any small business start-up, I am relatively unknown. I need to grow a reputation before I can be in demand. When I am in demand, I will generate more revenue. My reputation depends upon my product.</p><p>I am biased - I love my product, and I am working on improvements! The success of my business depends a lot on my product and reputation, and how well these specific jobs are performed.</p><p><strong>Jobs at <Link to="/">www.jesserivest.com</Link>:</strong></p><ul><li><strong>Performing Artist</strong><br />This is the most important, most rewarding job for me. I perform music, and I love it! I try to focus on this job, in some capacity, every day. I need to practice, that is very important. I need to create, too - songwriting. Oh, and I need to learn new musical things, too, like theory and techniques! This job is actually quite tiring, but in a fabulous and satisfying way.</li><li><strong>Booking Agent</strong><br />Someone has to deal and negotiate with music promoters, as well as research music venues and promoters in unfamiliar regions. The goal is to get me booked for a gig, for an agreeable fee. I've been spending a lot of time on this job, recently.<br />At this point, almost every region in the world is unfamiliar to me! I have been getting help with the research - people have been great at informing me of music venues in areas that I'd like to perform in. And sometimes I just gotta busk!</li><li><strong>Music Distributor</strong><br />Someone has to make my recorded music available to the public. Many recording artists outsource recorded music sales to a dedicated business. Agreements are made where the distributor receives a percentage of the income from the sales it oversees. <em>CDBaby</em> and I have such an agreement, but it is limited to their website on the internet. Other distributors have the power to put recorded music in every retail store in most countries! That seems a bit excessive. Essentially I am my own music distributor; my CDs are for sale from me, in person!</li><li><strong>Web Designer</strong><br />Someone has to keep this website updated and exciting! I spent some considerable time getting my website to where it is today. <em>This website is super important</em>, it is one of my best resources for spreading the word about me and my music. You can help spread the word if you like, I won't hold you back.</li><li><strong>Publicist</strong><br />Someone who prepares publishable material on the topic of me and my music, and then arranges for it to be published, publically. That's redundant. I don't do much in this area, aside from my website. I am sure there are many free places where I could publish things about me, but I'm just one man and my manager hasn't yet coordinated this one into my schedule. I don't think I'm ready to outsource this job, I need to build a bit more reputation first.</li><li><strong>Manager</strong><br />Oooh, this one is fun! someone has to ensure that I am practicing, relaxing, excercising, eating healthy, working hard, smiling, sleeping, etc... all in balance! They have to ensure that all the other jobs are being performed smoothly, too. I sometimes neglect this job, yet it is very important.</li><li><strong>Music Promoter</strong><br />Someone who organizes a show - a music event. Arrangements are made with the performing artists, and a venue is arranged. The promoter supports the event financially, takes a financial risk, and sometimes also seeks sponsorship. The promoter needs to get the public interested in the show through public service announcements, posters, flyers, publications, etc. Tickets need to be sold for the show, either in advance or at the door. Arrangements should be made for food or drink sales, which increase revenue at the event. A sound system (and sound expert) may need to be arranged for the venue, and sometimes lighting is needed.<br />This is a time consuming job; I know a music promoter in Calgary who can verify this. My goal is be attractive to music promoters; I want to <em>deal</em> with them. If music promoters won't deal with me, it could possibly be financially rewarding for me to be the music promoter for my own shows.</li></ul>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 5:01 PM &nbsp;
			</div>











		<h4 className="blogitemtitle">
		June is quiet, July is silent
		</h4>





			<div className="blogitembody">
			I am part of two shows in Calgary this June, while I have nothing planned for July. I may have some dates in B.C. this August and September, too! I am starting to focus my time on booking a tour in New Zealand and Australia for later this year and into next year.<br /><br />I am excited to get out and play my music, to see what people think of my songs and my performances. If my tour plans are not successful for New Zealand and Australia, I am going to travel there anyways and make it happen the hard way, like I did in Australia the first time... show up, work, and live!<br /><br />Want to see the bookings I have confirmed for June?
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 4:59 PM &nbsp;
			</div>






		<p>
			<Link to="/blog2005/">Go back to the blog index page</Link>
		</p>
</Old2005BlogPage>
  </Layout>
)

export default OldBlogPage;
